/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolRedeemIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-redeem"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M3.85 17.3L3.85 19.1Q3.85 19.1 3.85 19.1Q3.85 19.1 3.85 19.1L20.15 19.1Q20.15 19.1 20.15 19.1Q20.15 19.1 20.15 19.1L20.15 17.3ZM3.85 5.2L4.85 5.2Q4.85 4.97 4.85 4.75Q4.85 4.53 4.85 4.3Q4.85 2.77 5.92 1.7Q7 0.63 8.55 0.63Q9.45 0.63 10.21 1.07Q10.97 1.52 11.55 2.25L12 2.8L12.45 2.25Q13.03 1.55 13.81 1.09Q14.6 0.63 15.5 0.63Q17.05 0.63 18.13 1.7Q19.2 2.77 19.2 4.3Q19.2 4.53 19.2 4.75Q19.2 4.97 19.2 5.2L20.15 5.2Q21.25 5.2 22.02 5.97Q22.8 6.75 22.8 7.85L22.8 19.1Q22.8 20.2 22.02 20.98Q21.25 21.75 20.15 21.75L3.85 21.75Q2.75 21.75 1.98 20.98Q1.2 20.2 1.2 19.1L1.2 7.85Q1.2 6.75 1.98 5.97Q2.75 5.2 3.85 5.2ZM3.85 13.7L20.15 13.7L20.15 7.85Q20.15 7.85 20.15 7.85Q20.15 7.85 20.15 7.85L15.75 7.85L17.15 9.8Q17.48 10.22 17.38 10.75Q17.27 11.28 16.82 11.6Q16.4 11.9 15.89 11.82Q15.38 11.75 15.05 11.32L12 7.2L8.9 11.35Q8.57 11.78 8.06 11.85Q7.55 11.93 7.1 11.6Q6.67 11.3 6.58 10.76Q6.47 10.22 6.78 9.8L8.15 7.85L3.85 7.85Q3.85 7.85 3.85 7.85Q3.85 7.85 3.85 7.85ZM8.55 5.38Q8.55 5.38 8.76 5.38Q8.97 5.38 9.29 5.06Q9.6 4.75 9.6 4.33Q9.6 3.9 9.29 3.59Q8.97 3.27 8.55 3.27Q8.13 3.27 7.81 3.59Q7.5 3.9 7.5 4.33Q7.5 4.75 7.81 5.06Q8.13 5.38 8.55 5.38ZM15.5 5.38Q15.93 5.38 16.24 5.06Q16.55 4.75 16.55 4.33Q16.55 3.9 16.24 3.59Q15.93 3.27 15.5 3.27Q15.07 3.27 14.76 3.59Q14.45 3.9 14.45 4.33Q14.45 4.75 14.76 5.06Q15.07 5.38 15.5 5.38Z" fill={color} />
    </svg>
  );
}
